import React from "react";
import { AuditDetailsField as AuditDetailsFieldHelper } from "./helpers";
import { AuditDetailsFormData, FieldProps } from "./models";

interface AuditDetailsFieldOptions {
  labelPrefix: string;
}

interface AuditDetailsFieldProps extends FieldProps<AuditDetailsFormData> {}

export const AuditDetailsFieldComponent = (props: AuditDetailsFieldProps) => {
  const { id, schema, uiSchema, formData } = props;
  const rawLabel = schema.title;

  const options = uiSchema && (uiSchema["ui:options"] as AuditDetailsFieldOptions);
  const label = options && options.labelPrefix ? `${options.labelPrefix} ${rawLabel}` : rawLabel;

  const { at, userName, personName } = formData;

  return <AuditDetailsFieldHelper id={id} label={label} at={at} userName={userName} personName={personName} />;
};

export const AuditDetailsField = AuditDetailsFieldComponent;
